// extracted by mini-css-extract-plugin
module.exports = {"cookiePolicy":"CookiePolicy-module--cookie-policy--1_V5r"};